"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var styles = {
  "highlight": "highlight_2rcwke"
}; 
require('./Highlight.css');
var HIGHLIGHT_REGEXP = /([\s\S]*?)<em>([\s\S]+?)<\/em>/;
var Highlight = function Highlight(props) {
  var children = props.children;
  if (!children) {
    return null;
  }
  var pendingContent = children;
  var content = [];
  var key = 0;
  while (HIGHLIGHT_REGEXP.test(pendingContent)) {
    var _HIGHLIGHT_REGEXP$exe = HIGHLIGHT_REGEXP.exec(pendingContent),
      _HIGHLIGHT_REGEXP$exe2 = (0, _slicedToArray2.default)(_HIGHLIGHT_REGEXP$exe, 3),
      match = _HIGHLIGHT_REGEXP$exe2[0],
      text = _HIGHLIGHT_REGEXP$exe2[1],
      highlight = _HIGHLIGHT_REGEXP$exe2[2];
    pendingContent = pendingContent.substring(match.length);
    key += 1;
    if (text) {
      content.push(/*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
        key: "text-".concat(key)
      }, text));
    }
    content.push(/*#__PURE__*/_react.default.createElement("em", {
      key: "html-".concat(key),
      className: styles.highlight
    }, highlight));
  }
  if (pendingContent) {
    content.push(/*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: "pending"
    }, pendingContent));
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, content.map(function (item) {
    return item;
  }));
};
Highlight.defaultProps = {
  children: null
};
var _default = exports.default = Highlight;
//# sourceMappingURL=Highlight.js.map